import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';

@Component({
    name: 'CmgChipotleURewardsExchangeHeadBanner',
})
export default class CmgChipotleURewardsExchange extends Vue {
    mounted() {
        this.$services.loyalty.refreshPoints();
    }

    get chevronLeftUrl(): string {
        return this.$appStore.state.cms.images.icons.chevronLeftPlain.default;
    }

    get chipotleULogo(): string {
        return this.$appStore.state.cms.images.loyalty.chipotleULogo.default;
    }

    get backgroundImage(): string | undefined {
        return this.isMobile
        ? this.$appStore.state.cms.images.loyalty.rewardsExchangeHeadBannerBackground.mobile
        : this.$appStore.state.cms.images.loyalty.rewardsExchangeHeadBannerBackground.desktop;
    }


    get pointsBalance(): number {
        return this.$services.reward.getPointsBalance();
    }

    get isMobile(): boolean {
        return this.$services.ui.isMobile();
    }
    
    get isServiceOnline(): boolean {
        return !this.$appStore.state.reward.unreachable;
    }

    get isRewardsExchangeOnline(): boolean {
        return this.$appStore.state.featureFlags.orderingStatus?.isRewardsExchangeOnline ?? true;
    }

    get isRewardsOnline(): boolean {
        return this.$appStore.state.featureFlags.orderingStatus?.isRewardsOnline ?? true;
    }

    get rewardsExchangeOfflineMessage(): string {
        return `We're having trouble with our Rewards ${ !this.isRewardsOnline ? '' : 'Exchange ' }but you can still order, earn points and use existing rewards. Check back later.`;
    }

    onClickBack() {
        window.location.href = this.$router.resolve({ name: Routes.Rewards }).href;
    }

    onClickPointsHistory() {
        this.$services.googleAnalytics.sendCustomEvent({
            category: AnalyticsEventCategory.RewardsLanding,
            action: AnalyticsEventAction.ViewPointHistoryClick,
            label: AnalyticsEventLabel.ViewPointHistoryClick,
        });
        this.$services.ui.nextFocus('points');
        this.$router.push({ name: Routes.RewardsPointsHistory });
    }

}